import React from 'react';

const DashboardApi = () => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');
  const [result, setResult] = React.useState(null);

  React.useEffect(() => {
    const loadDashboardApi = async () => {
      try {
        const response = await fetch('https://smartapidev.smart-is.com/api/proxy', {
          method: 'POST',
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Url: 'https://dashboardsdev.smart-is.com/api/sso/me',
            HttpVerb: 'Get',
          }),
        });

        const data = await response.json();
        setResult(data);

        if (!response.ok) {
          setError(`Request failed with status ${response.status}`);
        }
      } catch (err) {
        setError(err?.message || 'Unable to call dashboard API.');
      } finally {
        setLoading(false);
      }
    };

    loadDashboardApi();
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h3>Dashboard API Response</h3>
      {loading && <p>Loading...</p>}
      {!loading && error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && (
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default DashboardApi;
